/* eslint-disable react-hooks/exhaustive-deps */
import { yupResolver } from "@hookform/resolvers/yup"
import {
  ActionButton,
  Button,
  Input,
  Select
} from "components"
import { Fragment, useEffect, useMemo } from "react"
import {
  Controller,
  FormProvider,
  useForm,
} from "react-hook-form"
import { TbEye } from "react-icons/tb"
import { FormStateProjectProfile } from "../types/ProfileTypes"
import { useToggle } from "utils"
import { DataResourcesType, validationResourcesSchema } from "../types/ResourcesTypes"
import { group_list, status_resources } from "../utils/resourcesOption"
import { useTrader } from "pages/Finance/Transaction/components/widgets/FormSection/components/Trader/utils"
import { SelectOptionType } from "types"
import { GroupName } from "pages/Finance/Transaction/types"

type Action = "add" | "edit"

type ItemProps = {
  index?: number
  action: Action
  defaultValues?: DataResourcesType
  isHideForm?: boolean
  onCancelEditing?: () => void
  onDeleteData?: () => void
  onSubmitData: (value: DataResourcesType) => void
  employee: SelectOptionType[]
  dataProject: FormStateProjectProfile
}

export function TableResourcesItem(props: ItemProps) {
  const isHideForm = useToggle(props.isHideForm ?? true)
  const { data:dataTrader, isLoading:isLoadingTrader, refetch:refetchTrader } = useTrader()

  const defaultValues: DataResourcesType = useMemo(
    () => ({
        project_resources_id: props?.defaultValues?.project_resources_id ?? null,
        project_id: props?.dataProject.project_id ?? 0,
        group_card: props?.defaultValues?.group_card ?? 0,
        card_id: props?.defaultValues?.card_id ?? 0,
        card_name: props?.defaultValues?.card_name ?? "",
        description: props?.defaultValues?.description ?? "",
        employee_id: props.defaultValues?.employee_id ?? 0,
        employee_name: props?.defaultValues?.employee_name ?? "",
        status: props?.defaultValues?.status ?? "",
    }),
    [props.defaultValues]
  )

  const methods = useForm<DataResourcesType>({
    defaultValues,
    resolver: yupResolver(validationResourcesSchema)
  })

  useEffect(() => methods.reset(defaultValues), [defaultValues])

  
  const { watch } = methods;
  const group_card = watch("group_card")

  useEffect(() => {
    if (Boolean(group_card)) {
      refetchTrader(String(group_card) as GroupName)
    }

    // eslint-disable-next-line
  }, [group_card])

  return (
    <FormProvider {...methods}>
      <tr className="no-padding-body">
        <td className="text-center">
          {isHideForm.isActive && (
            <Button
              color="transparent"
              onClick={isHideForm.toggle}
              permission="AT021">
              <TbEye className="size-5" />
            </Button>
          )}
        </td>
        {isHideForm.isActive ? (
          <td colSpan={9} />
        ) : (
          <Fragment>
            <td>
              <Controller
                control={methods.control}
                name="group_card"
                render={({ field }) => (
                  <Select
                    className="grow"
                    placeholder="Select Group Card"
                    options={group_list}
                    ref={field.ref}
                    value={
                      group_list.find((item) => Number(item.value) === Number(field.value)) ??
                      null
                    }
                    onChange={(item) => {
                      field.onChange(item?.value)
                      methods.setValue("card_id", 0)
                    }}
                  />
                )}
              />
            </td>
            <td>
              <Controller
                control={methods.control}
                name="card_id"
                render={({ field, fieldState }) => (
                  <Select
                    showPlaceholder
                    className="grow"
                    placeholder="Select Trader Name"
                    error={fieldState.error?.message}
                    isDisabled={Boolean(!group_card && group_card === 0)}
                    isLoading={isLoadingTrader}
                    options={dataTrader}
                    ref={field.ref}
                    value={dataTrader.find(item => Number(item.value) === Number(field.value)) ?? null}
                    onChange={(item) => {
                      field.onChange(item?.value)
                      methods.setValue("card_name", item?.label)
                    }}
                  />
                )}
              />
            </td>
            <td>
              <Controller
                control={methods.control}
                name="description"
                render={({ field, fieldState }) => (
                  <Input
                    {...field}
                    placeholder="Enter Description"
                    error={fieldState.error?.message}
                  />
                )}
              />
            </td>
            <td>
              <Controller
                control={methods.control}
                name="employee_id"
                render={({ field, fieldState }) => (
                  <Select
                    showPlaceholder
                    className="grow"
                    placeholder="Reported to"
                    error={fieldState.error?.message}
                    options={props.employee}
                    ref={field.ref}
                    value={props.employee.find(item => Number(item.value) === Number(field.value)) ?? null}
                    onChange={(item) => {
                      field.onChange(item?.value)
                      methods.setValue("employee_name", item?.label)
                    }}
                  />
                )}
              />
            </td>

            <td>
              <Controller
                control={methods.control}
                name="status"
                render={({ field, fieldState }) => (
                  <Select
                    showPlaceholder
                    className="grow"
                    placeholder="Status"
                    error={fieldState.error?.message}
                    options={status_resources}
                    ref={field.ref}
                    value={status_resources.find(item => Number(item.value) === Number(field.value)) ?? null}
                    onChange={item => field.onChange(item?.value)}
                  />
                )}
              />
            </td>
          
            <td className="text-center">
              <section className="flex justify-center items-center">
                {props.action === "edit" && (
                  <ActionButton.Close
                    permission="AT021"
                    onClick={props?.onCancelEditing}
                  />
                )}

                <ActionButton.Add
                  permission="AT021"
                  onClick={() => {
                    methods.handleSubmit((data) =>
                      props.onSubmitData(data)
                    )()
                  }}
                />

                {props.action === "add" && (
                  <ActionButton.Close
                    permission="AT021"
                    onClick={isHideForm.toggle}
                  />
                )}
              </section>
            </td>
          </Fragment>
        )}
      </tr>
    </FormProvider>
  )
}
